class CartNotesComponent extends HTMLElement {
  constructor() {
    super();
    this.textarea = null;
    this.debounceTimer = null;
    this.DEBOUNCE_MS = 500;
  }

  connectedCallback() {
    this.textarea = this.querySelector('textarea[name="note"]');
    if (!this.textarea) return;
    this.textarea.addEventListener('input', this.handleInput.bind(this));
  }

  handleInput() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.saveNote(), this.DEBOUNCE_MS);
  }

  async saveNote() {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: this.textarea.value }),
      });
      if (!res.ok) throw new Error(`Failed to save note: ${res.status}`);
    } catch (err) {
      console.error('[CartNotes] save failed', err);
    }
  }
}

customElements.define('cart-notes', CartNotesComponent);
